/**
 * Generate an RFC 4122 v4 UUID.
 *
 * Uses the Web Crypto API (`crypto.randomUUID`) which is available natively
 * in Node 19+ and all modern browsers (Chrome 92+, Firefox 95+, Safari 15.4+).
 *
 * Replaces the `uuid` npm package to remove a third-party dependency that
 * has recurring advisories around its external-buffer API.
 */
export function v4(): string {
    return crypto.randomUUID();
}
